<div class="pt-survey-initial-screen__wrapper">
  <div class="pu-back-btn pt-survey-initial-screen__button">
    <a
      type="button"
      puButton
      size="s"
      uiType="quaternary"
      (click)="backToInitialScreen.emit()"
      translate="userVote.buttons.back"
    ></a>
  </div>

  <img
    class="pt-survey-initial-screen__cover-image"
    [src]="survey().coverImage.url"
    [alt]="survey().coverImage.name"
  >

  <div class="pt-survey-initial-screen__info">
    <div class="pt-survey-initial-screen__info-additional">
      <div class="pt-survey-initial-screen__info-period">
        <span>{{ translateSlug() + '.initial.period' | translate }}</span>

        <div class="pt-survey-initial-screen__info-period_date">{{ survey().startDate | date: 'd MMM, y' }} - {{
            survey().endDate | date: 'd MMM, y' }}
        </div>
      </div>

      @if (survey().estimatedTime) {
        <div class="pt-survey-initial-screen__info-estimated-time">
          <span>{{ translateSlug() + '.initial.estimatedTime' | translate }}</span>
          <div class="pt-survey-initial-screen__info-estimated-time_time">~{{ survey().estimatedTime }} min</div>
        </div>
      }

      @if (survey().reward > 0) {
        <div class="pt-survey-initial-screen__info-reward">
          <span>{{ translateSlug() + '.initial.reward' | translate }}</span>
          <div class="pt-survey-initial-screen__info-reward-coins">{{ survey().reward }} <pt-coin/></div>
        </div>
      }

      @if (survey().achievement) {
        <div class="pt-survey-initial-screen__info-achievement">
          <span>{{ translateSlug() + '.initial.achievement' | translate }}</span>

          <div class="pt-survey-initial-screen__info-achievement-content">
            <div class="pt-survey-initial-screen__info-achievement-name">{{ survey().achievement.name }}</div>
            <img
              class="pt-survey-initial-screen__info-achievement-img"
              ptImageLoader
              [src]="survey().achievement.image.url"
              [alt]="survey().achievement.image.name"
            >
          </div>
        </div>
      }
    </div>

    @if (survey().isAnonymous) {
      <div class="pt-survey-initial-screen__info-anonymous">
        <pu-icon [iconName]="'eye-off-crossed'" size="20" />
        {{ 'myVotesAndSurveys.anonymous.' + translateSlug().slice(4).toLowerCase() + '.disclaimer' | translate }}
      </div>
    }

    <h3 class="pt-survey-initial-screen__info-name">{{ survey().name }}</h3>

    <div
      class="pt-survey-initial-screen__info-description"
      [froalaView]="survey().description"
    ></div>
  </div>

  <div class="pt-survey-initial-screen__button pt-survey-initial-screen__button-start">
    @if (survey().isResponded) {
      <button
        type="button"
        puButton
        size="l"
        uiType="secondary"
        disabled
        [translate]="translateSlug() + '.buttons.alreadyParticipated'"
      ></button>
    } @else {
      <button
        type="button"
        puButton
        size="l"
        uiType="primary"
        [translate]="translateSlug() + '.buttons.start'"
        [disabled]="isDisabled()"
        (click)="onStartSurvey()"
      ></button>
    }
  </div>
</div>
